# only show the highest priority modal
angular.module('rjmNg.directives').config([
  "$provide"
  ($provide) ->
    $provide.decorator '$modal', [
      "$delegate"
      "$q"
      "$rootScope"
      ($delegate, $q, $rootScope) ->

        modalQueue = []  # modals to show ordered high to low priority
        currentModalPromise = null #keep track if a modal is open

        _showNext = ->
          #shift off the current modal and show it if there is one
          currentModalPromise = modalQueue.shift()?.promise
          currentModalPromise?.then (modalElement) ->
            modalElement.modal("show")

        (config) ->
          # don't show right away
          config.show = false
          #when the current modal is closed how the next modal
          config.scope or= $rootScope.$new()
          config.scope.$on 'modal-hide', _showNext 

          modalPromise = $delegate config
          modalQueue.push 
            promise: modalPromise
            priority: if config.priority? then config.priority else 0
          #sort hight to low
          modalQueue.sort (lModal, rModal) ->  rModal.priority - lModal.priority
          # for each modal created check to see if no modals currently exist and show the
          # highest priority modal in the queue when the modal's promise is resolved completes
          modalPromise.then (modalElement) ->
            unless currentModalPromise?
              _showNext()

          return modalPromise
    ]
])
